import { useMemo, useState } from "react";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import PageHeader from "@/components/feature/PageHeader";
import FilterChips from "@/components/base/FilterChips";
import Pagination from "@/components/base/Pagination";
import EmptyState from "@/components/base/EmptyState";
import PlotCard from "@/components/feature/PlotCard";
import { plotItems, plotTags } from "@/mocks/content";

const PAGE_SIZE = 6;
const sortOptions = [
  { value: "episode", label: "按剧集顺序" },
  { value: "updated", label: "按更新时间" },
];

export default function PlotCategory() {
  useDocumentMeta({
    title: "我的朋友他的妻子 - 剧情介绍",
    description: "详细介绍影视剧《我的朋友他的妻子》的剧情发展与章节内容解析。",
    keywords: "我的朋友他的妻子,剧情介绍,分集剧情,情节解析",
    canonical: "https://dalian-stay.com.cn/category/plot",
  });

  const [tag, setTag] = useState("全部");
  const [sort, setSort] = useState("episode");
  const [page, setPage] = useState(1);

  const filtered = useMemo(() => {
    const list = plotItems.filter(
      (item) => tag === "全部" || item.tags.includes(tag),
    );
    return [...list].sort((a, b) =>
      sort === "updated" ? b.updatedAt.localeCompare(a.updatedAt) : a.order - b.order,
    );
  }, [tag, sort]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const paged = filtered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  const handleTag = (value: string) => {
    setTag(value);
    setPage(1);
  };
  const handleSort = (value: string) => {
    setSort(value);
    setPage(1);
  };

  return (
    <>
      <PageHeader
        title="剧情介绍"
        subtitle="一场十年前被遗忘的雨夜，一段无人知晓的往事。跟随分集剧情，逐步揭开《我的朋友他的妻子》的情感脉络。"
        crumbs={[{ label: "首页", to: "/" }, { label: "剧情介绍" }]}
      />

      <div className="mx-auto w-full max-w-content px-4 py-8 md:px-6 md:py-12">
        <div className="mb-8 flex flex-col gap-4 rounded-lg border border-background-300 bg-background-50 p-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <span className="mt-1 shrink-0 text-sm text-foreground-500">
              <i className="ri-price-tag-3-line mr-1"></i>
              主题
            </span>
            <FilterChips options={plotTags} value={tag} onChange={handleTag} />
          </div>
          <label className="flex shrink-0 items-center gap-2 text-sm text-foreground-600">
            <i className="ri-sort-desc"></i>
            <select
              value={sort}
              onChange={(e) => handleSort(e.target.value)}
              className="rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-800 outline-none focus:border-primary-400"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
        </div>

        {paged.length === 0 ? (
          <EmptyState message="未找到符合条件的剧情介绍" icon="ri-book-2-line" />
        ) : (
          <>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {paged.map((item) => (
                <PlotCard key={item.id} item={item} />
              ))}
            </div>
            <Pagination page={currentPage} totalPages={totalPages} onChange={setPage} />
          </>
        )}
      </div>
    </>
  );
}